module.exports = __webpack_public_path__ + "static/media/dropdown-icon.9cac6166.svg";